import { API_BASE_URL, fetchConToken } from '../utils/fetch.ts';

/**
 * Obtener transferencias filtradas por estado
 */
export const obtenerTransferencias = async (estado = null) => {
  try {
    let url = `khipu/admin/listar`;
    if (estado) {
      url += `?estado=${estado}`;
    }
    
    const resp = await fetchConToken(url, {}, 'GET');
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener transferencias:', error);
    return { error: true, data: [] };
  }
};

/**
 * Obtener transferencia por ID
 */
export const obtenerTransferenciaPorId = async (id) => {
  try {
    const resp = await fetchConToken(`khipu/admin/detalle/${id}`, {}, 'GET');
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al obtener transferencia:', error);
    return { error: true };
  }
};

/**
 * Aprobar transferencia
 */
export const aprobarTransferencia = async (id, comentario = '') => {
  try {
    const resp = await fetchConToken(`khipu/admin/${id}/aprobar`, {
      comentario
    }, 'POST');
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al aprobar transferencia:', error);
    return { error: true };
  }
};

/**
 * Rechazar transferencia
 */
export const rechazarTransferencia = async (id, comentario = '') => {
  try {
    const resp = await fetchConToken(`khipu/admin/${id}/rechazar`, {
      comentario
    }, 'POST');
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error al rechazar transferencia:', error);
    return { error: true };
  }
};

export default {
  obtenerTransferencias,
  obtenerTransferenciaPorId,
  aprobarTransferencia,
  rechazarTransferencia
};
